<div class="search-modal">
  <div class="search-input-header">
    <mat-icon class="search-icon">search</mat-icon>
    <input 
      type="text" 
      [(ngModel)]="query" 
      (ngModelChange)="onSearch()" 
      placeholder="Buscar clientes, productos..." 
      autofocus
    >
    <div class="esc-badge">ESC</div>
  </div>

  <div class="search-results-container" *ngIf="query.length >= 2">
    <div class="loading-bar" *ngIf="isLoading">
        <div class="progress"></div>
    </div>

    <div class="results-list" *ngIf="results.length > 0; else noResults">
      <div 
        class="result-item" 
        *ngFor="let res of results" 
        (click)="navigate(res.route)"
      >
        <div class="icon-avatar" [attr.data-type]="res.type">
          <mat-icon>{{ res.icon }}</mat-icon>
        </div>
        <div class="result-info">
          <span class="res-name">{{ res.name | titlecase }}</span>
          <span class="res-sub"><strong>{{ res.type }}</strong> • {{ res.sub }}</span>
        </div>
        <mat-icon class="arrow">chevron_right</mat-icon>
      </div>
    </div>

    <ng-template #noResults>
      <div class="no-results" *ngIf="!isLoading">
        <mat-icon>sentiment_dissatisfied</mat-icon>
        <p>No encontramos nada para "{{ query }}"</p>
      </div>
    </ng-template>
  </div>

  <div class="search-footer">
    <div class="hint">
      <span class="key">↑↓</span> para navegar
      <span class="key">ENTER</span> para seleccionar
    </div>
  </div>
</div>
